(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mouse-trail"] && !Shopify.designMode) return;
  try {
    customElements.define(
    'mouse-wakey',
    class MouseWakey extends HTMLElement {
      constructor() {
        super();

        // Read settings from data attributes (lerp comes as 0-10, convert to 0-1)
        // Scale by devicePixelRatio to compensate for retina displays feeling slower
        const baseLerp = (parseFloat(this.dataset.lerp) || 2) / 10;
        const dprScale = 1 + (Math.min(window.devicePixelRatio, 2) - 1) * 0.5;
        this.lerpFactor = baseLerp * dprScale;
        this.idleDelay = parseInt(this.dataset.idleDelay) || 3000;
        this.resetDelay = parseInt(this.dataset.resetDelay) || 1000;

        this.trailItems = this.querySelectorAll('[data-trail] > *');
        this.mouseX = 0;
        this.mouseY = 0;
        this.positions = [];
        this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
        this.clickHandler = this.clickHandler.bind(this);
        this.animate = this.animate.bind(this);
        this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);
        this.mouseEnterHandler = this.mouseEnterHandler.bind(this);
        this.resizeHandler = this.resizeHandler.bind(this);
        this.resetTimeout = null;
        this.isActive = window.matchMedia('(width >= 47rem)').matches;
        this.animationId = null;
        this.isAnimating = false;
        this.idleTimeout = null;
      }

      connectedCallback() {
        window.addEventListener('resize', this.resizeHandler);
        this.updateZIndex();
        this.initializePositions();

        if (this.isActive) {
          this.activate();
        }
      }

      initializePositions() {
        const rect = this.getBoundingClientRect();
        this.mouseX = rect.width / 2;
        this.mouseY = rect.height / 2;
        this.positions = Array.from({ length: this.trailItems.length }).map(() => ({ x: this.mouseX, y: this.mouseY }));
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.resizeHandler);
        this.deactivate();
      }

      resizeHandler() {
        const wasActive = this.isActive;
        this.isActive = window.matchMedia('(width >= 47rem)').matches;

        if (this.isActive && !wasActive) {
          this.initializePositions();
          this.activate();
        } else if (!this.isActive && wasActive) {
          this.deactivate();
        } else if (this.isActive) {
          this.initializePositions();
        }
      }

      activate() {
        this.addEventListener('mousemove', this.mouseMoveHandler);
        this.addEventListener('mouseleave', this.mouseLeaveHandler);
        this.addEventListener('mouseenter', this.mouseEnterHandler);
        this.trailItems.forEach((item) => {
          item.addEventListener('click', this.clickHandler);
        });
        this.startAnimation();
      }

      deactivate() {
        this.removeEventListener('mousemove', this.mouseMoveHandler);
        this.removeEventListener('mouseleave', this.mouseLeaveHandler);
        this.removeEventListener('mouseenter', this.mouseEnterHandler);
        this.trailItems.forEach((item) => {
          item.removeEventListener('click', this.clickHandler);
        });
        this.stopAnimation();
      }

      mouseMoveHandler(event) {
        const rect = this.getBoundingClientRect();
        this.mouseX = event.clientX - rect.left;
        this.mouseY = event.clientY - rect.top;

        // Restart animation on mouse movement
        this.startAnimation();

        // Reset idle timer
        clearTimeout(this.idleTimeout);
        this.idleTimeout = setTimeout(() => {
          this.stopAnimation();
        }, this.idleDelay);
      }

      mouseLeaveHandler() {
        this.resetTimeout = setTimeout(() => {
          const rect = this.getBoundingClientRect();
          this.mouseX = rect.width / 2;
          this.mouseY = rect.height / 2;
        }, this.resetDelay);
      }

      mouseEnterHandler() {
        clearTimeout(this.resetTimeout);
      }

      clickHandler() {
        const trailContainer = this.querySelector('[data-trail]');
        if (trailContainer && this.trailItems.length > 1) {
          const lastItem = this.trailItems[this.trailItems.length - 1];
          trailContainer.prepend(lastItem);
          // Re-query the trail items to update the NodeList
          this.trailItems = this.querySelectorAll('[data-trail] > *');
          this.updateZIndex();
        }
      }

      updateZIndex() {
        this.trailItems.forEach((item, index) => {
          item.style.zIndex = this.trailItems.length - index;
        });
      }

      startAnimation() {
        if (!this.isAnimating && this.isActive) {
          this.isAnimating = true;
          this.animate();
        }
      }

      stopAnimation() {
        this.isAnimating = false;
        if (this.animationId) {
          cancelAnimationFrame(this.animationId);
          this.animationId = null;
        }
        clearTimeout(this.idleTimeout);
      }

      animate() {
        if (!this.isActive || !this.isAnimating) return;

        this.positions.forEach((position, index) => {
          if (index === 0) {
            position.x += (this.mouseX - position.x) * this.lerpFactor;
            position.y += (this.mouseY - position.y) * this.lerpFactor;
          } else {
            position.x += (this.positions[index - 1].x - position.x) * this.lerpFactor;
            position.y += (this.positions[index - 1].y - position.y) * this.lerpFactor;
          }

          const item = this.trailItems[index];
          const itemRect = item.getBoundingClientRect();
          const offsetX = itemRect.width / 2;
          const offsetY = itemRect.height / 2;

          item.style.transform = `translate3d(${position.x - offsetX}px, ${position.y - offsetY}px, 0)`;
        });

        this.animationId = requestAnimationFrame(this.animate);
      }
    }
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["reviews"] && !Shopify.designMode) return;
  try {
    (function() {
  function initReviewsBlock(blockElement) {
    const loadMoreButton = blockElement.querySelector('[data-load-more]');
    if (!loadMoreButton) return;

    const maxReviews = parseInt(blockElement.dataset.maxReviews, 10);
    const loadMoreText = blockElement.dataset.loadMoreText;

    let currentlyVisible = parseInt(blockElement.dataset.initialCount, 10);
    const reviewItems = Array.from(blockElement.querySelectorAll('.reviews-block__item'));
    const totalReviews = reviewItems.length;

    const loadIncrement = 5;

    loadMoreButton.addEventListener('click', function() {
      const nextVisible = Math.min(currentlyVisible + loadIncrement, maxReviews, totalReviews);

      for (let i = currentlyVisible; i < nextVisible; i++) {
        if (reviewItems[i]) {
          reviewItems[i].classList.remove('is-hidden');
        }
      }

      currentlyVisible = nextVisible;

      if (currentlyVisible >= totalReviews || currentlyVisible >= maxReviews) {
        loadMoreButton.disabled = true;
        loadMoreButton.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function initAllBlocks() {
    const blocks = document.querySelectorAll('.reviews-block');
    blocks.forEach(function(block) {
      initReviewsBlock(block);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBlocks);
  } else {
    initAllBlocks();
  }

  document.addEventListener('shopify:section:load', function(event) {
    const blocks = event.target.querySelectorAll('.reviews-block');
    blocks.forEach(function(block) {
      initReviewsBlock(block);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
